import userList from './userList'
import userInfo from './userInfo'
import userRegister from './userRegister'
import userRecharge from './userRecharge'
import userConsumerBill from './userConsumerBill'
import professionalRenderingUpdateRecord from './professionalRenderingUpdateRecord'
import agentsApplication from './agentsApplication'
import userMessageBoard from './userMessageBoard'
import studentCertification from './studentCertification'
import enterpriseCertification from './enterpriseCertification'
import clientFeedback from './clientFeedback'
import pictureClientFeedback from './pictureClientFeedback'
import animationClientFeedback from './animationClientFeedback'
import wechatMsg from './wechatMsg'
import copyrightRegistration from './copyrightRegistration'
import userDuplicationCheck from './userDuplicationCheck'

export default {
  namespaced: true,
  modules: {
    userList,
    userInfo,
    userRegister,
    userRecharge,
    userConsumerBill,
    professionalRenderingUpdateRecord,
    agentsApplication,
    userMessageBoard,
    studentCertification,
    enterpriseCertification,
    clientFeedback,
    pictureClientFeedback,
    animationClientFeedback,
    wechatMsg,
    copyrightRegistration,
    userDuplicationCheck,
  },
}
